import { useEffect, useState } from "react";

import { useFetchMe } from "@/user/services";
import { type NotificationType, notify } from "@/utils";

import NotificationItem from "./NotificationItem";
import UserNotifications from "./UserNotifications";

export default function NotificationContainer() {
  const { data: user } = useFetchMe();

  const [notifications, setNotifications] = useState<NotificationType[]>([]);

  useEffect(() => {
    notify.callback = (notifications) => setNotifications(notifications);
    setNotifications(notify.listNotify);

    return () => (notify.callback = undefined);
  }, []);

  return (
    <div className="pointer-events-none fixed top-4 z-60 flex w-full items-start sm:end-6 sm:top-6">
      <div className="flex w-full flex-col items-center gap-2 sm:items-end">
        {user && <UserNotifications />}
        {notifications.map((notification) => (
          <NotificationItem
            key={notification.id}
            notification={notification}
            onRequestHide={() => notify.remove(notification)}
          />
        ))}
      </div>
    </div>
  );
}
